import { useElementSize } from "@/hooks/useLayout";
import BoardLegend, { LEGEND_GAP, LEGEND_H } from "@/components/game/BoardLegend";
import { S_MAX, S_REF, SEA_BAND, TRAY_PAD } from "@/lib/terrain";

// Board tray + coast band + legend, filling the centre column (the board sits at the top).
// 3D BOARD: square size S = the largest that fits both the column width and height, at most
// 112 px. The tray (#E3DED3) has 20 px padding top and left and 12 px right and bottom, so the
// tallest blocks have room to lift; the deep-water band (44 px at S = 112, scales with S) runs
// along the bottom edge of the board inside the tray; the legend sits 8 px under the tray.
// boardStyle: Focus dimming (opacity only, never blocks clicks).
export default function BoardArea({ cols, rows, renderBoard, renderCoast, boardStyle }) {
  const [ref, size] = useElementSize();
  const padX = TRAY_PAD.left + TRAY_PAD.right;
  const padY = TRAY_PAD.top + TRAY_PAD.bottom;
  const byW = (size.width - padX) / cols;
  const byH = (size.height - padY - LEGEND_GAP - LEGEND_H) / (rows + SEA_BAND / S_REF);
  const S = Math.max(20, Math.floor(Math.min(byW, byH, S_MAX)));
  const seaH = Math.round((SEA_BAND * S) / S_REF);
  const gridW = cols * S;
  const boardW = gridW + padX;

  return (
    <div ref={ref} data-testid="board-area" className="relative w-full flex-1 min-h-0 flex flex-col items-center justify-start">
      {size.width > 0 && (
        <>
          <div data-testid="board-frame" data-square={S} className="focus-region shrink-0" style={{ width: boardW, ...boardStyle }}>
            <div
              data-testid="board-tray"
              style={{ background: "var(--board)", padding: `${TRAY_PAD.top}px ${TRAY_PAD.right}px ${TRAY_PAD.bottom}px ${TRAY_PAD.left}px`, borderRadius: 12 }}
            >
              <div className="relative" style={{ width: gridW, height: rows * S, isolation: "isolate" }}>
                {renderBoard(S)}
              </div>
              <div data-testid="coastal-frame" style={{ width: gridW, height: seaH }}>
                {renderCoast(S)}
              </div>
            </div>
          </div>
          <BoardLegend maxWidth={size.width} />
        </>
      )}
    </div>
  );
}
